import posthog from 'posthog-js';

/**
 * Identify a user (set user properties)
 */
export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (!userId) {
    return;
  }
  posthog.identify(userId, properties);
};

/**
 * Update person properties (persistent)
 */
export const updateUserProperties = (properties: Record<string, any>) => {
  if (!properties) {
    return;
  }
  posthog.people.set(properties);
};

/**
 * Capture an event (non-persistent)
 */
export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
  if (!eventName) {
    return;
  }
  posthog.capture(eventName, properties);
};
